import React from 'react';
import { FormSection, change as formChange } from 'redux-form';
import { connect } from 'react-redux';

import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { TextField } from 'src/components/Form';
import { calEstimatedAnnualEarnings as calAnnualEarnings } from 'jbc-front/utils/calculation';
import ExtensionSelectField from 'src/components/ExtensionSelectField';
import selector, { getOptionLabel } from 'src/utils/Utils';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import { getSelectOptions } from 'src/reducers/selectOptions';
import PayrollRuleInfo from './PayrollRuleInfo';
import { useTranslation } from 'react-i18next';
import { isThaiMoney } from 'src/utils/CustomValidators';
import { getCurrentUserInfo, isRoleTypeAdmin } from 'src/reducers/users/currentUser';

const fetchpayrollRuleInfo = (payrollRulesGroups, clientPayrollRulesGroupId) =>
  payrollRulesGroups.find(p => p.id === clientPayrollRulesGroupId) || {};

const PayrollRuleSection = props => {
  const {
    payrollRulesGroups,
    baseSalaryNames,
    selectedClientPayrollRulesGroupId,
    currentUser,
    onChangeYearlyIncome
  } = props;
  const { t } = useTranslation();
  return (
    <div>
      <FormSection name="employeePayrollRule">
        <ExtensionSelectField
          required
          label={t('features.Employees.components.PayrollRuleSection.salary_rule_group')}
          name="clientPayrollRulesGroupId"
          options={payrollRulesGroups}
        />

        {selectedClientPayrollRulesGroupId && (
          <PayrollRuleInfo payrollRule={fetchpayrollRuleInfo(payrollRulesGroups, selectedClientPayrollRulesGroupId)} />
        )}

        {isRoleTypeAdmin(currentUser.roleType) && (
          <TextField
            label={getOptionLabel(selectedClientPayrollRulesGroupId)(baseSalaryNames)}
            type="text"
            name="baseSalary"
            validate={isThaiMoney}
            yen
          />
        )}
      </FormSection>
    </div>
  );
};

export default connect(
  state => ({
    payrollRulesGroups: getSelectOptions(state, 'payrollRulesGroups'),
    baseSalaryNames: getSelectOptions(state, 'baseSalaryNames'),
    currentUser: getCurrentUserInfo(state) || {},
    selectedClientPayrollRulesGroupId: selector(
      getEmployeeFormValues(state),
      'employeePayrollRule',
      'clientPayrollRulesGroupId'
    )
  }),
  dispatch => ({
    onChangeYearlyIncome: (e, value) => {
      const yearlyEarning = calAnnualEarnings(value);
      dispatch(formChange(EMPLOYEE_FORM, 'employeePayrollRule.yearlyEarning', yearlyEarning));
    }
  })
)(PayrollRuleSection);
